import { URLS } from "@app/shared";
import aboutUsHero from "@assets/images/about-us/about-us-hero.png";
import { PageHeader, type BreadcrumbItem } from "@design-system/components";
import { trans } from "@mongez/localization";

export function AboutUsHeroSection() {
  const breadcrumbItems: BreadcrumbItem[] = [
    { label: trans("home"), link: URLS.home },
    { label: trans("aboutSenaat") },
  ];

  const taglines = [
    trans("aboutUsPage.heroSection.taglines.first"),
    trans("aboutUsPage.heroSection.taglines.second"),
  ];

  return (
    <PageHeader
      translationKey="aboutUs"
      breadcrumbItems={breadcrumbItems}
      image={aboutUsHero}
      imageAlt="Industrial power transmission tower viewed from below"
    >
      <div className="container flex flex-col gap-4 ps-0 text-sm font-light leading-5 sm:gap-10 lg:gap-12 lg:text-xl lg:leading-7 xl:flex-row xl:gap-20 xl:text-2xl xl:leading-[33px]">
        <div className="w-full xl:w-fit">
          {taglines.length > 0 && (
            <div className="min-w-max space-y-3 lg:space-y-4 xl:space-y-6">
              <h2 className="text-lg font-semibold leading-tight lg:text-[36px] xl:text-[48px]">
                {taglines[0]} <br />
                {taglines[1]}
              </h2>
            </div>
          )}
        </div>

        <div className="rlt:text-right opacity-80 xl:w-full">
          <p className="font-light">
            {trans("aboutUsPage.heroSection.content.paragraph1")}
          </p>

          <p className="py-2 font-bold text-white lg:py-3 xl:py-5">
            {trans("aboutUsPage.heroSection.content.paragraph2")}
          </p>

          <p>{trans("aboutUsPage.heroSection.content.paragraph3")}</p>
        </div>
      </div>
    </PageHeader>
  );
}
